import { FormField } from '../../../types/form-builder.types';
import { Input } from '@shondalai/ui-commons';

interface SliderFieldProps {
  field: FormField;
  value: number;
  onChange: (value: number) => void;
}

export function SliderField({ field, value, onChange }: SliderFieldProps) {
  const config = field.config;
  const min = (config as any).min || 0;
  const max = (config as any).max || 100;
  const step = (config as any).step || 1;
  const disabled = (config as any).disabled;

  return (
    <div className="easyforms-slider-field">
      <div className="space-y-2">
        <div className="flex items-center justify-between">
          <span className="text-sm text-muted-foreground">{min}</span>
          <span className="text-lg font-semibold">{value || min}</span>
          <span className="text-sm text-muted-foreground">{max}</span>
        </div>
        <Input
          id={field.id}
          type="range"
          min={min}
          max={max}
          step={step}
          value={value || min}
          onChange={(e) => onChange(Number(e.target.value))}
          disabled={disabled}
          className="w-full"
        />
      </div>
      {config.helpText && (
        <p className="text-xs text-muted-foreground mt-1">{config.helpText}</p>
      )}
    </div>
  );
}


